import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import {
  Link,
  useNavigate,
  useLocation,
  NavLink,
  location,
} from "react-router-dom";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import axios from "../api/axios";
import axio from "axios";
import styles from "./styles.module.css";
import Footer from "./Footer";

const LOGIN_URL = "/auth";

const navigation = [
  /*{ name: "Product", href: "#" },
  { name: "Features", href: "#" },
  { name: "Marketplace", href: "#" },
  { name: "Company", href: "#" },*/
];

const userRole = {
  Admin: 5150,
  Ent: 1984,
  User: 2001,
  Auditor: 2023,
  Disable: 1001,
  Permit: 3600,
  Unit: 1981,
};

const Login = () => {
  const { setAuth, auth, navigate } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userIP, setUserIP] = useState("");
  const [country, setCountry] = useState("");
  const [userAgent, setUserAgent] = useState("");

  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState("");
  const [password, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [error, setError] = useState("");

  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year.toString());
  }, []);

  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  let userTypes = "";

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axio.get("https://ipapi.co/json/");
        const data = response.data;
        setUserIP(data.ip); // Extract and set the user's IP address
        setCountry(data.country_name);
        // console.log(data.country_name);
      } catch (error) {
        //console.log("Error fetching user data:", error);
      }
    };

    fetchUserData();

    // Get user agent
    setUserAgent(navigator.userAgent);
  }, []);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
    if (user.length > 0 && password.length > 0) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [user, password]);

  useEffect(() => {
    localStorage.setItem("newauth", JSON.stringify(auth));
    return () => {
      setIsMounted(false);
    };
  }, [auth]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const email = user;
    try {
      setLoading(true);

      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ email, password }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      const enable = response?.data?.result.enabled;

      /* if (!enable) {
        setError("This user is disabled");
        setLoading(false);
        return; // Return early if the user is disabled
      }*/
      if (roles.includes(userRole.Permit)) {
        setError(
          `This user needs approval
        Please try again in a few minutes.`
        );
        setLoading(false);
        return; // Return early if the user needs Approval
      }

      const result = response?.data.result;
      //console.log(JSON.stringify(response?.data.result));
      // console.log(JSON.stringify(response));

      setAuth({ user, result, roles, accessToken });
      setUser("");
      setPwd("");
      //console.log(auth.result);
      const hasAdminRole = roles.includes(5150);
      const hasEntRole = roles.includes(1984);
      const hasUserRole = roles.includes(2001);
      const hasAuditorRole = roles.includes(2023);

      if (hasAdminRole) {
        userTypes = "Administrator";
      } else if (hasEntRole) {
        userTypes = "Enterprise";
      } else if (hasUserRole) {
        userTypes = "User";
      } else if (hasAuditorRole) {
        userTypes = "Auditor";
      }

      const auditTrailData = {
        userId: email,
        action: "login",
        details: {
          ipAddress: userIP, // Use the extracted user's IP address
          userAgent: userAgent,
          country: country,
        },
        status: "Successful",
        usertype: userTypes,
      };

      try {
        const response = await axios.post("/auditTrail", auditTrailData);
        //console.log("Audit trail entry saved successfully:", response.data);
      } catch (error) {
        //console.error("Error saving audit trail entry:", error);
      }

      setLoading(false);
      navigate("/");
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        const auditTrailData = {
          userId: email,
          action: "login",
          details: {
            ipAddress: userIP, // Use the extracted user's IP address
            userAgent: userAgent,
            country: country,
          },
          status: "Failed",
          usertype: "Guest",
        };

        console.log(auditTrailData);

        try {
          const response = await axios.post("/auditTrail", auditTrailData);
          //console.log("Audit trail entry saved successfully:", response.data);
        } catch (error) {
          //console.error("Error saving audit trail entry:", error);
        }
        setLoading(false);
        setError(error.response.data.message);
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  function PrivacyModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
        <div className="bg-white p-5 rounded-lg shadow-lg relative max-w-lg w-full mx-auto">
          {" "}
          {/* Adjust width as needed */}
          <h2 className="text-lg font-bold">Privacy Policy</h2>
          <div className="privacy-policy-content overflow-y-auto max-h-[80vh]">
            {" "}
            {/* Set maximum height and make it scrollable */}
            {/* Your privacy policy content goes here */}
            <p>
              <strong>Effective Date:</strong> 1st January, 2025
            </p>
            <p>
              Welcome to <em>Bverify</em>. We are committed to protecting your
              privacy and ensuring that your information is handled securely and
              responsibly. This Privacy Policy outlines how we collect, use, and
              safeguard your data when you use our identity verification
              platform. By using our services, you agree to the practices
              described in this Privacy Policy.
            </p>
            <h2>1. Information We Collect</h2>
            <p>
              We collect information necessary to perform identity verification,
              including but not limited to:
            </p>
            <ul>
              <li>
                Personal Identifiable Information (PII) such as name, address,
                date of birth, and identification documents.
              </li>
              <li>Verification data submitted by authorized individuals.</li>
            </ul>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>
                Verify identities and confirm the authenticity of submitted
                data.
              </li>
              <li>
                Provide a secure and efficient identity verification process.
              </li>
              <li>Comply with applicable laws and regulations.</li>
            </ul>
            <h2>3. Responsibilities of the Verifier</h2>
            <p>
              Individuals or entities initiating a verification request
              (“Verifier”) are accountable for the following:
            </p>
            <ul>
              <li>
                <strong>Authorization:</strong> The Verifier warrants that they
                are authorized to perform the verification and have obtained all
                necessary consents from the individual whose identity is being
                verified.
              </li>
              <li>
                <strong>Accountability:</strong> The Verifier is solely
                responsible for ensuring the verification is conducted in
                accordance with all applicable laws and regulations.
              </li>
              <li>
                <strong>Accuracy:</strong> The Verifier is responsible for the
                accuracy and legitimacy of the information they provide during
                the verification process.
              </li>
            </ul>
            <blockquote>
              <strong>Caveat:</strong> Any misuse of the platform, unauthorized
              access, or breach of privacy caused by the Verifier will result in
              full accountability. The Verifier agrees to indemnify and hold{" "}
              <em>[Your Platform Name]</em> harmless from any liability arising
              from such actions.
            </blockquote>
            <h2>4. Data Security</h2>
            <p>
              We implement industry-standard measures to protect your data,
              including encryption, access controls, and regular audits.
              However, the Verifier must ensure the confidentiality and security
              of the data they access during the verification process.
            </p>
            <h2>5. Sharing of Information</h2>
            <p>
              We do not share personal information with third parties except
              when:
            </p>
            <ul>
              <li>Required by law.</li>
              <li>Necessary for the completion of the verification process.</li>
            </ul>
            <h2>6. Rights of Individuals</h2>
            <p>Verified individuals have the right to:</p>
            <ul>
              <li>Access the information held about them.</li>
              <li>Request corrections to any inaccuracies.</li>
              <li>Withdraw consent for future verifications.</li>
            </ul>
            <h2>7. Changes to this Privacy Policy</h2>
            <p>
              We reserve the right to update this Privacy Policy at any time.
              All changes will be communicated through updates on our platform.
            </p>
            <h2>8. Contact Us</h2>
            <p>
              For questions or concerns about this Privacy Policy, please
              contact us at:
            </p>
            <ul>
              <li>
                <strong>Email:</strong> info@ficoven.com
              </li>
            </ul>
            <p>
              By using our platform, you acknowledge and agree to this Privacy
              Policy and accept full responsibility for your actions as a
              Verifier.
            </p>
          </div>
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-lg font-bold"
          >
            &times; {/* Close Icon */}
          </button>
        </div>
      </div>
    );
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (event) => {
    event.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = (event) => {
    event.preventDefault(); // This will prevent the default action of the event
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="relative isolate bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
          <div className="relative px-6 pb-20 pt-16 sm:pt-20 lg:static lg:px-8 lg:py-36">
            <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
              <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
                <svg
                  className="absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                      width={200}
                      height={200}
                      x="100%"
                      y={-1}
                      patternUnits="userSpaceOnUse"
                    >
                      <path d="M130 200V.5M.5 .5H200" fill="none" />
                    </pattern>
                  </defs>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="white"
                  />
                  <svg
                    x="100%"
                    y={-1}
                    className="overflow-visible fill-gray-50"
                  >
                    <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                  </svg>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                  />
                </svg>
              </div>
              <img
                src="/images/logo.png"
                alt="My Image"
                width={120}
                height={20}
              />

              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                <p>
                  <img src="images/banner.png" />
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  Welcome to <em>Bverify</em> an identity verification platform!
                  We empower businesses and individuals by ensuring authenticity
                  through reliable identity and information verification.
                </p>
              </div>
            </div>
          </div>

          <form
            onSubmit={handleSubmit}
            className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48"
          >
            <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Sign in to your account
              </h2>
              <p className="mt-2 text-sm leading-6 text-gray-500">
                Don't have an account yet?{" "}
                <NavLink to="/register" className="font-semibold main-text">
                  Sign up
                </NavLink>
              </p>
              {error && (
                <div className={"w-full px-2 " + styles.error_msg}>{error}</div>
              )}
              <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <div className="sm:col-span-2">
                  <label
                    htmlFor="email"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    Email
                  </label>
                  <div className="mt-2.5">
                    <input
                      name="email"
                      type="email"
                      id="username"
                      ref={userRef}
                      autoComplete="off"
                      onChange={(e) => setUser(e.target.value)}
                      value={user}
                      required
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
                <div className="mt-2.5 password-wrapper sm:col-span-2">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    autoComplete="current-password"
                    id="password"
                    onChange={(e) => setPwd(e.target.value)}
                    value={password}
                    placeholder="Password"
                    className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                  />
                  <div
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? "🙈" : "👀"}
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 main-text"
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-3 block text-sm leading-6 text-gray-700"
                  >
                    Remember me
                  </label>
                </div>
                <div className="text-sm leading-6">
                  <NavLink
                    to="/forgotpassword"
                    className="font-semibold  main-text"
                  >
                    Forgot password?
                  </NavLink>
                </div>
              </div>
              <div className="mt-6">
                <button
                  type="submit"
                  disabled={buttonDisabled}
                  className="w-full rounded-md px-4 py-3 text-center text-lg font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 hover-blue"
                >
                  {loading ? "Loading..." : "Sign in"}
                </button>
              </div>
              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                {/* Navigation Bar */}
                <nav className="flex justify-center space-x-8">
                  <NavLink to="/register">
                    <span className="cursor-pointer text-lg font-semibold text-gray-900">
                      Signup
                    </span>
                  </NavLink>
                  <NavLink to="#" onClick={openModal}>
                    <span className="cursor-pointer text-lg font-semibold text-gray-900">
                      Privacy
                    </span>
                  </NavLink>
                </nav>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PrivacyModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Login;
